var holidays = [
  {
    'year' : 2019,
    'holis' : [
      {
        'date' : '2019-01-01',
        'day' : 'New Year\'s Day'
      },
      {
        'date' : '2019-01-28',
        'day' : 'Australia Day'
      },
      {
        'date' : '2019-04-19',
        'day' : 'Good Friday'
      },
      {
        'date' : '2019-04-20',
        'day' : 'Easter Saturday'
      },
      {
        'date' : '2019-04-21',
        'day' : 'Easter Sunday'
      },
      {
        'date' : '2019-04-22',
        'day' : 'Easter Monday'
      },
      {
        'date' : '2019-04-25',
        'day' : 'Anzac Day'
      },
      {
        'date' : '2019-12-24',
        'day' : 'Christmas Eve'
      },
      {
        'date' : '2019-12-25',
        'day' : 'Christmas Day'
      },
      {
        'date' : '2019-12-26',
        'day' : 'Boxing Day'
      },
      {
        'date' : '2019-12-31',
        'day' : 'New Year\'s Eve'
      },
    ]
  },
  {
    'year' : 2020,
    'holis' : [
      {
        'date' : '2019-01-01',
        'day' : 'New Year\'s Day'
      },
      {
        'date' : '2019-01-27',
        'day' : 'Australia Day'
      },
      {
        'date' : '2019-04-10',
        'day' : 'Good Friday'
      },
      {
        'date' : '2019-04-11',
        'day' : 'Easter Saturday'
      },
      {
        'date' : '2019-04-12',
        'day' : 'Easter Sunday'
      },
      {
        'date' : '2019-04-13',
        'day' : 'Easter Monday'
      },
      {
        'date' : '2019-04-25',
        'day' : 'Anzac Day'
      },
      {
        'date' : '2019-12-24',
        'day' : 'Christmas Eve'
      },
      {
        'date' : '2019-12-25',
        'day' : 'Christmas Day'
      },
      {
        'date' : '2019-12-26',
        'day' : 'Boxing Day'
      },
      {
        'date' : '2019-12-31',
        'day' : 'New Year\'s Eve'
      },
    ]
  },
  {
    'year' : 2021,
    'holis' : [
      {
        'date' : '2019-01-01',
        'day' : 'New Year\'s Day'
      },
      {
        'date' : '2019-01-26',
        'day' : 'Australia Day'
      },
      {
        'date' : '2019-04-02',
        'day' : 'Good Friday'
      },
      {
        'date' : '2019-04-03',
        'day' : 'Easter Saturday'
      },
      {
        'date' : '2019-04-04',
        'day' : 'Easter Sunday'
      },
      {
        'date' : '2019-04-05',
        'day' : 'Easter Monday'
      },
      {
        'date' : '2019-04-25',
        'day' : 'Anzac Day'
      },
      {
        'date' : '2019-12-24',
        'day' : 'Christmas Eve'
      },
      {
        'date' : '2019-12-25',
        'day' : 'Christmas Day'
      },
      {
        'date' : '2019-12-26',
        'day' : 'Boxing Day'
      },
      {
        'date' : '2019-12-31',
        'day' : 'New Year\'s Eve'
      },
    ]
  },
  {
    'year' : 2022,
    'holis' : [
      {
        'date' : '2019-01-01',
        'day' : 'New Year\'s Day'
      },
      {
        'date' : '2019-01-26',
        'day' : 'Australia Day'
      },
      {
        'date' : '2019-04-15',
        'day' : 'Good Friday'
      },
      {
        'date' : '2019-04-16',
        'day' : 'Easter Saturday'
      },
      {
        'date' : '2019-04-17',
        'day' : 'Easter Sunday'
      },
      {
        'date' : '2019-04-18',
        'day' : 'Easter Monday'
      },
      {
        'date' : '2019-04-25',
        'day' : 'Anzac Day'
      },
      {
        'date' : '2019-12-24',
        'day' : 'Christmas Eve'
      },
      {
        'date' : '2019-12-25',
        'day' : 'Christmas Day'
      },
      {
        'date' : '2019-12-26',
        'day' : 'Boxing Day'
      },
      {
        'date' : '2019-12-31',
        'day' : 'New Year\'s Eve'
      },
    ]
  },
  {
    'year' : 2023,
    'holis' : [
      {
        'date' : '2019-01-01',
        'day' : 'New Year\'s Day'
      },
      {
        'date' : '2019-01-26',
        'day' : 'Australia Day'
      },
      {
        'date' : '2019-04-07',
        'day' : 'Good Friday'
      },
      {
        'date' : '2019-04-08',
        'day' : 'Easter Saturday'
      },
      {
        'date' : '2019-04-09',
        'day' : 'Easter Sunday'
      },
      {
        'date' : '2019-04-10',
        'day' : 'Easter Monday'
      },
      {
        'date' : '2019-04-25',
        'day' : 'Anzac Day'
      },
      {
        'date' : '2019-12-24',
        'day' : 'Christmas Eve'
      },
      {
        'date' : '2019-12-25',
        'day' : 'Christmas Day'
      },
      {
        'date' : '2019-12-26',
        'day' : 'Boxing Day'
      },
      {
        'date' : '2019-12-31',
        'day' : 'New Year\'s Eve'
      },
    ]
  },
  {
    'year' : 2024,
    'holis' : [
      {
        'date' : '2019-01-01',
        'day' : 'New Year\'s Day'
      },
      {
        'date' : '2019-01-26',
        'day' : 'Australia Day'
      },
      {
        'date' : '2019-03-29',
        'day' : 'Good Friday'
      },
      {
        'date' : '2019-03-30',
        'day' : 'Easter Saturday'
      },
      {
        'date' : '2019-03-31',
        'day' : 'Easter Sunday'
      },
      {
        'date' : '2019-04-01',
        'day' : 'Easter Monday'
      },
      {
        'date' : '2019-04-25',
        'day' : 'Anzac Day'
      },
      {
        'date' : '2019-12-24',
        'day' : 'Christmas Eve'
      },
      {
        'date' : '2019-12-25',
        'day' : 'Christmas Day'
      },
      {
        'date' : '2019-12-26',
        'day' : 'Boxing Day'
      },
      {
        'date' : '2019-12-31',
        'day' : 'New Year\'s Eve'
      },
    ]
  },
  {
    'year' : 2025,
    'holis' : [
      {
        'date' : '2019-01-01',
        'day' : 'New Year\'s Day'
      },
      {
        'date' : '2019-01-27',
        'day' : 'Australia Day'
      },
      {
        'date' : '2019-04-18',
        'day' : 'Good Friday'
      },
      {
        'date' : '2019-04-19',
        'day' : 'Easter Saturday'
      },
      {
        'date' : '2019-04-20',
        'day' : 'Easter Sunday'
      },
      {
        'date' : '2019-04-21',
        'day' : 'Easter Monday'
      },
      {
        'date' : '2019-04-25',
        'day' : 'Anzac Day'
      },
      {
        'date' : '2019-12-24',
        'day' : 'Christmas Eve'
      },
      {
        'date' : '2019-12-25',
        'day' : 'Christmas Day'
      },
      {
        'date' : '2019-12-26',
        'day' : 'Boxing Day'
      },
      {
        'date' : '2019-12-31',
        'day' : 'New Year\'s Eve'
      },
    ]
  }
];

function getOpen(theStore, whenNow) {

  if (typeof whenNow == 'undefined') {
    whenNow = 'now';
  }

  var results = {
    'isOpen' : true,
    'isOpenToday' : true,
    'status' : ''
  };

  if (theStore) {

    // set now
    var dayjs = require('dayjs');
    var isBetween = require('dayjs/plugin/isBetween');
    dayjs.extend(isBetween);
    var customParseFormat = require('dayjs/plugin/customParseFormat');
    dayjs.extend(customParseFormat);
    var now = dayjs();
    if (whenNow == 'tomorrow') {
      now.add(1, 'days');
    }
    var nowDay = now.format('dddd').toLowerCase();
    var isHoliday = false;
    results.now = now;

    // check if today is special closed
    if (theStore.specialDates) {
      theStore.specialDates.forEach(slot => {
        if (slot.closed) {
          if (now.isSame(slot.date, 'day')) {
            results.isOpenToday = false;
            results.isOpen = false;
            results.status = 'special';
          }
        }
      });
    }

    // check if today is a public holiday
    if (holidays) {
      holidays.forEach(slot => {
        if (slot.year == now.year()) {
          slot.holis.forEach(holi => {
            if (now.isSame(holi.date, 'day')) {
              nowDay = holi.day.toLowerCase();
              isHoliday = true;
              if (theStore.closedHolidays.includes(holi.day)) {
                results.isOpenToday = false;
                results.isOpen = false;
                results.status = 'holiday';
              }
            }
          });
        }
      });
    }

    // loop through days to compare
    if (results.isOpen) {

      // loop through normal hours
      theStore.hours.forEach(slot => {
        if (nowDay == slot.day || ( isHoliday && slot.day == 'holidays' ) ) {

          // check if closed
          if (slot.closed) {
            results.isOpenToday = false;
            results.isOpen = false;
            results.status = 'schedule';
          }

          if (results.isOpen) {

            // set open time
            var ot = dayjs(slot.openTime.date.replace(/-/g,'/').replace('.000000',''));
            if (whenNow == 'tomorrow') {
              var openTime = dayjs().hour(ot.hour()).minute(ot.minute()).add(1, 'day');
            } else {
              var openTime = dayjs().hour(ot.hour()).minute(ot.minute());
            }
            results.openTime = openTime;

            // set close time
            var ct = dayjs(slot.closeTime.date.replace(/-/g,'/').replace('.000000',''));
            if (whenNow == 'tomorrow') {
              var closeTime = dayjs().hour(ct.hour()).minute(ct.minute()).add(1, 'day');
            } else {
              var closeTime = dayjs().hour(ct.hour()).minute(ct.minute());
            }
            results.closeTime = closeTime;

            // is open?
            // if (typeof closeTime)
            if (now.isBetween(openTime, closeTime)) {
              results.isOpen = true;
              results.status = 'open';
            } else if (now.isBefore(openTime)) {
              results.isOpen = false;
              results.status = 'before';
            } else if (now.isAfter(openTime)) {
              results.isOpen = false;
              results.status = 'after';
            }

          }

        }
      });

      // loop through special hours override
      if (theStore.specialDates) {
        theStore.specialDates.forEach(slot => {
          if (!slot.closed) {
            if (now.isSame(slot.date.date, 'day')) {

              // set open time
              var ot = dayjs(slot.openTime.date.replace(/-/g,'/').replace('.000000',''));
              if (whenNow == 'tomorrow') {
                var openTime = dayjs().hour(ot.hour()).minute(ot.minute()).add(1, 'day');
              } else {
                var openTime = dayjs().hour(ot.hour()).minute(ot.minute());
              }
              results.openTime = openTime;

              // set close time
              var ct = dayjs(slot.closeTime.date.replace(/-/g,'/').replace('.000000',''));
              if (whenNow == 'tomorrow') {
                var closeTime = dayjs().hour(ct.hour()).minute(ct.minute()).add(1, 'day');
              } else {
                var closeTime = dayjs().hour(ct.hour()).minute(ct.minute());
              }
              results.closeTime = closeTime;

              // is open?
              // if (typeof closeTime)
              if (now.isBetween(openTime, closeTime)) {
                results.isOpen = true;
                results.status = 'open';
              } else if (now.isBefore(openTime)) {
                results.isOpen = false;
                results.status = 'before';
              } else if (now.isAfter(openTime)) {
                results.isOpen = false;
                results.status = 'after';
              }

            }
          }
        });
      }

    }

  }


  return results;
}

export function display(theStore) {

  var openText = '';

  if (theStore) {

    // get results
    var data = getOpen(theStore);

    // set wording
    if (data.isOpen) {
      openText = 'Open Today till ' + data.closeTime.format('h:mma');
    } else if (data.status == 'before') {
      openText = 'Open Today ' + data.openTime.format('h:mma') + ' - ' + data.closeTime.format('h:mma');
    } else if (data.status == 'after') {
      openText = 'Closed now';
    } else {
      openText = 'Closed today';
    }

  }

  return openText;
}

export function displaySimple(theStore) {

  var openText = '';

  if (theStore) {

    // get results
    var data = getOpen(theStore);

    // set wording
    if (data.isOpen) {
      openText = 'Open today';
    } else if (data.status == 'before') {
      openText = 'Open today';
    } else if (data.status == 'after') {
      openText = 'Closed now';
    } else {
      openText = 'Closed now';
    }

  }

  return openText;
}

function actual(hoursData) {

  var openText = '';

  if (hoursData.isOpenToday) {
    openText = hoursData.now.format('dddd') + ' ' + hoursData.openTime.format('h:mma') + ' - ' + hoursData.closeTime.format('h:mma');
  } else {
    openText = hoursData.now.format('dddd') + ' - Closed';
  }

  return openText;

}

export function outlook(theStore) {

  var openText = '';

  if (theStore) {

    // get results
    var data = getOpen(theStore);

    openText = actual(data);

    if ((data.isOpenToday && data.status == 'after') || !data.isOpenToday) {
      var tomorrow = getOpen(theStore, 'tomorrow');
      openText += '<br />' + actual(tomorrow)
    }

  }

  return openText;
}